import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { handleErrorMessage } from "../../../../helpers/methods";
import { getIndividualPlanetData } from "../../AnalysisService";
import PlanetsFlipCards from "./PlanetsFlipCards";

interface CustomProps {
  profileId?: string;
  setIsLoading: Function;
  house: any;
}

const Planets = (props: CustomProps) => {
  const [planetsData, setPlanetsData] = useState<any[]>([]);
  const { i18n } = useTranslation();

  const planets = [
    // English names
    "Ascendant",
    "Descendent",
    "Sun",
    "Moon",
    "Mercury",
    "Venus",
    "Mars",
    "Jupiter",
    "Saturn",
    "Uranus",
    "Neptune",
    "Pluto",
    "Rahu",
    "Ketu",
    "Medium Coeli",
    "Imum Coeli",
    // Polish names
    "Ascendent", // Ascendant
    "Słońce", // Sun
    "Księżyc", // Moon
    "Merkury", // Mercury
    "Wenus", // Venus
    "Jowisz", // Jupiter
    "Uran", // Uranus
    "Neptun", // Neptune
    "Pluton", // Pluto
  ];

  useEffect(() => {
    getPlanets();
  }, [i18n.language, props.house]);

  const getPlanets = async () => {
    try {
      props.setIsLoading(true);
      const language = i18n.language.toLowerCase();
      const response = await getIndividualPlanetData(
        props?.profileId!,
        props.house,
        language
      );
      setPlanetsData(response.rashiDetails);
      props.setIsLoading(false);
    } catch (error: any) {
      props.setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  return (
    <Grid container py={1}>
      {planetsData
        ?.map((data: any) => {
          if (planets.includes(data.point_name)) {
            return <PlanetsFlipCards flipCardData={data} />;
          } else return undefined;
        })
        .filter(Boolean)}
    </Grid>
  );
};

export default Planets;
